import { FC } from 'react';

import _ from 'lodash';
import { useFormContext } from 'react-hook-form';

import { ARCHES } from 'constants/prescriptionConstants';
import {
  ARCHES_TO_TREAT,
  PASSIVE_ALIGNERS
} from 'constants/prescriptionOptions';
import { translate } from 'utils';

import { FormLabel } from './FormLabel/FormLabel';
import RhfRadioGroup from './RadioGroup/RhfRadioGroup/RhfRadioGroup';
interface Props {
  isDisabled?: boolean;
}
const ArchesToTreat: FC<Props> = ({ isDisabled }) => {
  const {
    watch,
    formState: { errors }
  } = useFormContext();
  const watchArchesToTreat = watch(
    'treatmentSpecifications.ZenClearUltra.archesToTreat.arches'
  );
  const fieldError =
    _.get(
      errors,
      'treatmentSpecifications.ZenClearUltra.archesToTreat.arches'
    ) ||
    _.get(
      errors,
      'treatmentSpecifications.ZenClearUltra.archesToTreat.passiveAligners'
    );
  return (
    <div className='flex flex-col'>
      <FormLabel
        label={translate('prescription.step6_arch_to_treat')}
        className='md:text-17px mb-4'
        error={!!fieldError}
        name={'archesToTreat'}
      />
      <RhfRadioGroup
        inputProps={{ disabled: isDisabled }}
        options={ARCHES_TO_TREAT}
        name='treatmentSpecifications.ZenClearUltra.archesToTreat.arches'
        className='mt-2 flex flex-row space-x-16'
        radioClassName='border-RADIO_BORDER'
        radioItemFont='md:text-17px text-sm'
      />
      {(watchArchesToTreat === ARCHES.LOWER ||
        watchArchesToTreat === ARCHES.UPPER) && (
        <div className='flex flex-row space-x-4 items-center mt-2'>
          <p className='text-14px text-PRIMARY font-bold'>
            {translate(
              'arches_to_treat.do_you_need_passive_aligner_for_the_opposing_arch'
            )}
          </p>
          <RhfRadioGroup
            inputProps={{ disabled: isDisabled }}
            options={PASSIVE_ALIGNERS}
            name='treatmentSpecifications.ZenClearUltra.archesToTreat.passiveAligners'
            className=' flex flex-row space-x-16'
            radioClassName='border-RADIO_BORDER'
            radioItemFont='md:text-17px text-sm '
          />
        </div>
      )}
    </div>
  );
};
export default ArchesToTreat;
